module.exports = __webpack_public_path__ + "static/img/6areaB_5.d958849.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/6areaB_5.png
// module id = 1208
// module chunks = 1